import { useQuery } from "@tanstack/react-query";
import { authFetch } from "@/lib/authFetch";

export function useResellers() {
  return useQuery({
    queryKey: ["/api/resellers"],
    queryFn: async () => {
      const res = await authFetch("/api/resellers");
      if (!res.ok) throw new Error("Failed to fetch resellers");
      return res.json();
    },
  });
}
